<!--
 * @Description: 补发记录
 * @Author: gao shuai
 * @Date: 2020-07-03 09:20:00
 * @LastEditTime: 2020-07-16 16:04:44
 * @LastEditors: gao shuai
-->
<template>
  <div class="replaceRecord">
    <van-pull-refresh v-if="list.length>0" class="scrolldiv" v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :offset="80" :immediate-check="false" :finished="finished" finished-text="我是有底线的" @load="onLoad">
        <ul class="listbox">
          <li v-for="(item,i) in list" :key="''+i">
            <p>
              <span class="tit">补发时间：</span>
              <span class="txt">{{item.reissueDate}}</span>
            </p>
            <p>
              <span class="tit">玩家账号：</span>
              <span class="txt">{{item.playerAccount}}</span>
            </p>
            <p>
              <span class="tit">所属分区：</span>
              <span class="txt">{{item.partitionsName}}</span>
            </p>
            <p>
              <span class="tit">补发金额：</span>
              <span class="txt red">{{item.amount.toFixed(2)}}</span>
            </p>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
    <van-empty v-else description="暂无内容" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      PageNumber: 1,
      PageSize: 10,
      total: 0
    };
  },
  methods: {
    // 获取列表
    getlist() {
      this.$api.home
        .reorderList({
          Type: '',
          StartReissueDate: null,
          EndReissueDate: null,
          PlayerAccount: '',
          PartitionId: 0,
          PartitionName: '',
          PageNumber: this.PageNumber,
          PageSize: this.PageSize
        })
        .then((data) => {
          if (data.status === 200) {
            if (this.PageNumber === 1) {
              this.list = data.data;
            } else {
              this.list = this.list.concat(data.data);
            }
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
            if (this.list.length >= this.total) {
              this.finished = true;
            } else {
              this.finished = false;
              this.loading = false;
              this.PageNumber++;
            }
            this.refreshing = false;
          } else {
            this.list = [];
            this.refreshing = false;
            this.finished = false;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.refreshing = false;
          this.finished = false;
          this.loading = false;
          this.$toast(err.message);
        });
    },
    // 下拉刷新
    onRefresh() {
      this.PageNumber = 1;
      this.finished = false;
      this.loading = false;
      this.getlist();
    },
    // 上拉加载
    onLoad() {
      if (this.finished || this.refreshing) {
        this.loading = false;
        return;
      }
      this.getlist();
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.replaceRecord {
  height: 100%;
  overflow: hidden;
  .scrolldiv {
    height: 100%;
    overflow-y: auto;
  }
  .listbox {
    li {
      background: #fff;
      margin-bottom: 3px;
      border-bottom: 3px solid #ededed;
      padding: 10px 20px 6px;
      color: #5a5a5a;
      p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 2px;
        .tit {
          font-size: 13px;
        }
        .txt {
          font-size: 10px;
          &.red {
            color: red;
          }
        }
      }
    }
  }
}
</style>
